import React from 'react';
import { BrowserRouter } from "react-router-dom";

import HeaderAndFooter from './HeaderFooter/HeaderAndFooter';
import CustomRouter from './route';

import './CustomerPortal.css';
import CustomerPortalAction from '../../actions/CustomerPortalAction';

export default class Home extends React.Component {
    constructor(props) {
        super(props);
        var currentDate = new Date();
        var lastUpdate = new Date(localStorage.lastUpdate)
        let openpages = (localStorage.openpages && localStorage.openpages!='NaN')?(JSON.parse(localStorage.openpages)):({});
        if(typeof openpages != 'object') openpages = {};
        var yesterday = (currentDate - 28800000);
        var length = Object.keys(openpages).length;
        if(length>=0){
          Object.keys(openpages).map((key)=>{
            if(((openpages[key] - yesterday) <= 0)){
              length--;
            }
          })
          if(length <= 0 && !localStorage.lastUpdate){
            openpages = {};
            localStorage.removeItem('currentUser');
          }
        }
        if( localStorage.lastUpdate && ((currentDate - lastUpdate) >= 5000) ){
          localStorage.removeItem('currentUser');
        }
        localStorage.removeItem('lastUpdate');
        let pageID = new Date().getTime();
        openpages[pageID] = pageID;
        sessionStorage.setItem('pageID',pageID);
        localStorage.setItem('openpages', JSON.stringify(openpages));
        window.addEventListener('beforeunload', (event) => {
          if(localStorage.openpages){
            let openpages = (localStorage.openpages)?(JSON.parse(localStorage.openpages)):({});
            let pageID = sessionStorage.pageID;
            if(openpages[pageID]) delete openpages[pageID];
            if (Object.keys(openpages).length <= 0 ) {
              localStorage.removeItem('openpages');
              localStorage.setItem('lastUpdate',new Date())
            } else {
              localStorage.setItem('openpages', JSON.stringify(openpages));
            }
          }
        });
    }
    render(){
        return (
            <div className="customer-portal">
                <BrowserRouter>
                    <HeaderAndFooter>
                        <CustomRouter />
                    </HeaderAndFooter>
                </BrowserRouter>
            </div>
        );
    }
}
